// @ts-strict-ignore
import type { ServiceConfig } from '../types';
import { CredentialOwner } from '../types';

export const credentialUnknowLabel = 'Please select an owner';

export const UnknowOption = {
  label: credentialUnknowLabel,
  value: 'unknown',
};
export const AlloyOption = {
  label: 'Alloy',
  value: 'alloy',
};
export const CustomerOption = {
  label: 'Customer',
  value: 'customer',
};

export const serviceConfig: ServiceConfig = {
  serviceId: 1,
  selectedWorkflowOptions: [
    {
      actionId: 1,
      applicationName: 'app 1',
      applicationToken: 'TOKEN',
      version: 1,
      serviceNodeDisplayName: 'app 1 node 1',
      credentialOwner: CredentialOwner.customer,
      serviceConfigOptions: [
        {
          serviceConfigOptionId: 1,
          value: null,
          selectedValues: [1, 2],
        },
      ],
    },
    {
      actionId: 2,
      applicationName: 'app 2',
      applicationToken: 'TOKEN',
      version: 1,
      serviceNodeDisplayName: 'app 2 node 1',
      credentialOwner: CredentialOwner.customer,
      serviceConfigOptions: [
        {
          serviceConfigOptionId: 1,
          value: null,
          selectedValues: [1, 2],
        },
      ],
    },
  ],
  selectedAlloyOptions: {
    serviceConfigOptions: [
      {
        serviceConfigOptionId: 1,
        value: null,
        selectedValues: [1, 2, 3],
      },
      {
        serviceConfigOptionId: 2,
        value: null,
        selectedValues: [1, 2],
      },
      {
        serviceConfigOptionId: 3,
        value: null,
        selectedValues: [21],
      },
      {
        serviceConfigOptionId: 4,
        value: 'Https://service.socure.com',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 5,
        value: 'Categories',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 6,
        value: '99',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 7,
        value: '99.9',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 8,
        value: 'true',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 9,
        value: 'false',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 10,
        value: 'somePassword',
        selectedValues: null,
      },
    ],
  },
  selectedCustomerOptions: {
    credentialOwner: CredentialOwner.customer,
    serviceConfigOptions: [
      {
        serviceConfigOptionId: 1,
        value: null,
        selectedValues: [1, 2],
      },
      {
        serviceConfigOptionId: 3,
        value: null,
        selectedValues: [21],
      },
      {
        serviceConfigOptionId: 4,
        value: 'Https://service.socure.com',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 5,
        value: 'Categories',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 6,
        value: '99',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 7,
        value: '99.9',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 8,
        value: 'true',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 9,
        value: 'false',
        selectedValues: null,
      },
      {
        serviceConfigOptionId: 10,
        value: 'somePassword',
        selectedValues: null,
      },
    ],
  },
  serviceConfigOptions: [
    {
      serviceConfigOptionId: 1,
      isRequired: true,
      isOwner: true,
      isSecret: false,
      category: 'internal',
      datatype: 'multiselect',
      displayName: 'Modules',
      description: 'desc',
      possibleValues: [
        {
          displayName: 'KYC',
          serviceConfigPossibleValueId: 1,
          slug: 'kyc',
        },
        {
          displayName: 'Phone Risk',
          serviceConfigPossibleValueId: 2,
          slug: 'phone_risk',
        },
        {
          displayName: 'Address Risk',
          serviceConfigPossibleValueId: 3,
          slug: 'address_risk',
        },
        {
          displayName: 'something else',
          serviceConfigPossibleValueId: 4,
          slug: 'something_else',
        },
      ],
      slug: 'modules',
    },
    {
      serviceConfigOptionId: 2,
      isRequired: true,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'multiselect',
      displayName: 'Modules 2',
      description: 'desc',
      possibleValues: [
        {
          displayName: 'KYC',
          serviceConfigPossibleValueId: 1,
          slug: 'kyc',
        },
        {
          displayName: 'Phone Risk',
          serviceConfigPossibleValueId: 2,
          slug: 'phone_risk',
        },
        {
          displayName: 'Address Risk',
          serviceConfigPossibleValueId: 3,
          slug: 'address_risk',
        },
        {
          displayName: 'something else',
          serviceConfigPossibleValueId: 4,
          slug: 'something_else',
        },
      ],
      slug: 'modules_2',
    },
    {
      serviceConfigOptionId: 3,
      isRequired: true,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'singleselect',
      displayName: 'City',
      description: 'desc',
      possibleValues: [
        {
          displayName: 'NY',
          serviceConfigPossibleValueId: 21,
          slug: 'ny',
        },
        {
          displayName: 'others',
          serviceConfigPossibleValueId: 22,
          slug: 'others',
        },
      ],
      slug: 'city',
    },
    {
      serviceConfigOptionId: 4,
      isRequired: true,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'string',
      displayName: 'Base URL Alloy value',
      description: 'desc',
      possibleValues: null,
      slug: 'base_url_alloy_value',
    },
    {
      serviceConfigOptionId: 5,
      isRequired: false,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'string',
      displayName: 'Categories',
      description: 'desc',
      possibleValues: null,
      slug: 'categories',
    },
    {
      serviceConfigOptionId: 6,
      displayName: 'Score',
      possibleValues: null,
      description: 'desc',
      isRequired: true,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'integer',
      slug: 'score',
    },
    {
      serviceConfigOptionId: 7,
      displayName: 'Score decimal',
      possibleValues: null,
      description: 'desc',
      isRequired: true,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'decimal',
      slug: 'score_decimal',
    },
    {
      serviceConfigOptionId: 8,
      displayName: 'Accept Validation',
      possibleValues: null,
      description: 'desc',
      isRequired: false,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'boolean',
      slug: 'accept_validation',
    },
    {
      serviceConfigOptionId: 9,
      displayName: 'Accept Validation Error',
      possibleValues: null,
      description: 'desc',
      isRequired: false,
      isOwner: true,
      category: 'internal',
      isSecret: false,
      datatype: 'boolean',
      slug: 'accept_validation_error',
    },
    {
      serviceConfigOptionId: 10,
      displayName: 'Password',
      possibleValues: null,
      description: 'description',
      isRequired: true,
      isOwner: true,
      category: 'auth',
      isSecret: true,
      datatype: 'string',
      slug: 'password',
    },
  ],
};
